<template>
  <v-app class="grey lighten-4" :dark="dark">
    <Navbar />
    <Hero />
    <v-content class="grey lighten-5">
      <v-container fluid class="pa-0 ma-0">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import Hero from "@/components/Hero";
import Navbar from "@/components/Navbar";

export default {
  name: "App",

  components: {
    Hero,
    Navbar
  },
  computed: {
    ...mapState({
      dark: state => state.navigation.dark
    })
  }
};
</script>
<style>
</style>